import { CardFooter as _CardFooter, CardFooterProps as _CardFooterProps } from "reactstrap";

    export const CardFooter = _CardFooter;
    export type CardFooterProps = _CardFooterProps;
    